import React from "react";

export const NO_GROUP_TEXT = "необхідно вказати групу";

// Група студента; якщо не заповнена -- жовте нагадування (студента все одно видно).
const GroupLabel = ({ group }) =>
  group ? (
    <>{group}</>
  ) : (
    <span style={{ background: "#fff3cd", color: "#7a5b00", padding: "2px 6px", borderRadius: 4, fontWeight: 600 }}>
      {NO_GROUP_TEXT}
    </span>
  );

export default GroupLabel;
